export const data = [
  {
    id: '1',
    productName: 'Foxit software PhantomPDF Standard',
    tags: ['PDF', 'Change', 'Create', 'Maintenance', 'Business', 'FoxIT'],
    category: 'Daily Business',
    manufacturerUrl: 'https://www.foxitsoftware.com/de/pdf-editor',
    description: [
      'PhantomPDF provides powerful PDF Editor capabilities to allow authors to update their documents themselves.',
      'Standard - Simple interface and limited functionality.'
    ],
    option1: '1 Year Maintenance',
    option2: 'Without Maintenance'
  },
  {
    id: '2',
    productName: 'Foxit Software PhantomPDF Business',
    tags: [],
    category: 'Daily Business',
    manufacturerUrl: 'https://www.foxitsoftware.com/de/pdf-editor',
    description: [
      'PhantomPDF provides powerful PDF Editor capabilities to allow authors to update their documents themselves.',
      'Business - Advances capabilities, complete lifecycle solution.'
    ],
    option1: '1 Year Maintenance',
    option2: 'Without Maintenance'
  },
  {
    id: '3',
    productName: 'Autodesk AutoCAD 2020.x',
    tags: [
      'Autodesk',
      '3D Modeling',
      'Visualization',
      'Solid',
      'Surface',
      'Mesh Modeling',
      'Photorealistic Rendering',
      'Section Planes',
      'Visual Styles',
      '3D Navigation',
      '3D Scanning',
      'Base, Projected, and Section Views'
    ],
    category: 'Daily Business',
    manufacturerUrl: 'https://www.autodesk.com',
    description: [
      'AutoCAD® is computer-aided design (CAD) software that architects, engineers, and construction professionals rely on to create precise 2D and 3D drawings.',
      'Draft, annotate, and design 2D geometry and 3D models with solids, surfaces, and mesh objects.',
      'Automate tasks such as comparing drawings, adding blocks, creating schedules, and more.',
      'Customize with add-on apps and APIs.'
    ],
    option1: 'With Maintenance',
    option2: 'Without Maintenance'
  },
  {
    id: '4',
    productName: 'TechSmith Snagit',
    tags: ['Screen capture', 'Snipping tool', 'Snagit', 'TechSmith'],
    category: 'Daily Business',
    manufacturerUrl: 'https://www.techsmith.com/screen-capture.html',
    description: [
      'Capture any process on your computer screen and quickly create visual instructions.',
      '- Show customers and coworkers how to do something with screenshots and screen recordings.',
      '- Mark up your screenshots, or talk through a process and answer questions with a quick video.',
      '- Create custom how-to guides, tutorials, and quick videos right within Snagit'
    ],
    option1: 'With Maintenance',
    option2: 'Without Maintenance'
  },
  {
    id: '5',
    productName: 'TechSmith Camtasia',
    tags: ['TechSmith', 'Camtasia', 'Video Editor', 'Screen recorder'],
    category: 'Daily Business',
    manufacturerUrl: 'https://www.techsmith.com/video-editor.html',
    description: [
      'Camtasia lets you record a video of what’s on your computer screen. Use it to make lessons, tutorials, or product demos. Turn your screen recordings into compelling videos with Camtasia’s video editing tools, animations, and effects.'
    ],
    option1: null,
    option2: null
  },
  {
    id: '6',
    productName: 'ZeroTurnaround JRebel',
    tags: ['Java', 'Deployment', 'Zeroturnaround', 'Xrebel'],
    category: 'Developer',
    manufacturerUrl: 'https://www.jrebel.com/products/jrebel',
    description: [
      'JRebel is a productivity tool that allows developers to reload code changes instantly. It skips the rebuild, restart and redeploy cycle common in Java development. JRebel enables developers to get more done in the same amount of time and to stay in the flow while coding.'
    ],
    option1: 'New user',
    option2: 'Renewal for existing user'
  },
  {
    id: '7',
    productName: 'JetBrains PhpStorm 2020',
    tags: ['JetBrains', 'PhpStorm', 'Code', 'Database', 'Coding', 'Renewal'],
    category: 'Developer',
    manufacturerUrl: 'https://www.jetbrains.com/phpstorm',
    description: [
      "The editor actually 'gets' your code and deeply understands its structure, supporting all the PHP language features for modern and legacy projects. It provides the best code completion, refactoring, on-the-fly error prevention, and more."
    ],
    option1: null,
    option2: null
  },
  {
    id: '8',
    productName: 'JetBrain ReSharper Ultimate 2020.x',
    tags: ['JetBrains', 'ReSharper', '.NET', 'VisiualStudio', 'Extension', 'Code', 'Coding'],
    category: 'Developer',
    manufacturerUrl: 'https://www.jetbrains.com/resharper',
    description: [
      'The Visual Studio Extension for .NET Developers.',
      "Not only does ReSharper warn you when there's a problem in your code but it provides hundreds of quick-fixes to solve problems automatically."
    ],
    option1: null,
    option2: null
  },
  {
    id: '9',
    productName: 'Tableau Desktop Professional',
    tags: [
      'Tableau',
      'Desktop Professional',
      'Desktop Prof.',
      'Perpetual',
      'Maintenance',
      'Data visualization',
      'Business Intelligence',
      'Analytics'
    ],
    category: 'Data Analytics',
    manufacturerUrl: 'https://www.tableau.com/products/desktop',
    description: [
      'Tableau is a powerful and fastest growing data visualization tool used in the Business Intelligence Industry. It helps in simplifying raw data into the very easily understandable format. Data analysis is very fast with Tableau and the visualizations created are in the form of dashboards and worksheets.'
    ],
    option1: 'Perpetual',
    option2: 'Subscription'
  },
  {
    id: '10',
    productName: 'Zoom Meetingroom',
    tags: ['Zoom', 'Meetingrooms', 'Zoomrooms', 'Sharing content'],
    category: 'Daily Business',
    manufacturerUrl: 'https://zoom.us/zoomrooms',
    description: [
      'Zoom Rooms tackles the three biggest pain points of the conference room: Starting a meeting, booking a meeting, and sharing content.'
    ],
    option1: null,
    option2: null
  }
];
